import { IconProps } from '.';

function InfoIconTwo({ style, className }: IconProps) {
  return (
    <svg
      width="20" 
      height="20" 
      viewBox="0 0 16 17"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      style={style}
    >
      <title>InfoIconTwo</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.5 8.28467C16.5 3.86553 12.9191 0.284668 8.5 0.284668C4.08086 0.284668 0.5 3.86553 0.5 8.28467C0.5 9.6439 0.8395 10.9543 1.47848 12.1209C1.97079 13.0192 2.6296 13.8149 3.41644 14.4619C4.83778 15.6332 6.6193 16.2847 8.5 16.2847C12.9191 16.2847 16.5 12.7038 16.5 8.28467ZM1.5 8.28467C1.5 4.41781 4.63314 1.28467 8.5 1.28467C12.3669 1.28467 15.5 4.41781 15.5 8.28467C15.5 12.1515 12.3669 15.2847 8.5 15.2847C6.8535 15.2847 5.29626 14.7152 4.05198 13.6898C3.3633 13.1235 2.78653 12.4269 2.35547 11.6404C1.79673 10.6203 1.5 9.47496 1.5 8.28467ZM8 7.11967V12.1577C8 12.4338 8.22386 12.6577 8.5 12.6577C8.77614 12.6577 9 12.4338 9 12.1577V7.11967C9 6.84353 8.77614 6.61967 8.5 6.61967C8.22386 6.61967 8 6.84353 8 7.11967ZM8.5 4.41167C8.845 4.41167 9.125 4.69067 9.125 5.03667C9.125 5.38167 8.845 5.66167 8.5 5.66167C8.155 5.66167 7.875 5.38167 7.875 5.03667C7.875 4.69067 8.155 4.41167 8.5 4.41167Z" fill="currentColor"/>
    </svg>
  );
}

export default InfoIconTwo;
